<template>
  <div class="create-body">
    <el-dialog
      title="3D Authentication required"
      :visible.sync="show3dAuthModal"
      class="3dAuthModal"
      height="100%"
    >
      <iframe class="modalIframe" :src="redirectUrl" > </iframe>
    </el-dialog>
    <el-col :sm="12" class="info-section is-desktop">
      <el-row class="panel onboarding-info">
        <h1>The Future of <br>Stock Surveillance</h1>
        <el-row class="onboarding-description mb-25 mt-30">
          Sequire unlocks stock buyers’ behaviors and trends for issuers of
          publicly traded companies.
        </el-row>
        <el-row>
          <el-link
            href="https://mysequire.com/"
            target="_blank"
            :underline="false"
            v-track="{ event: 'login_learn' }"
            class="learn-more-link"
          >
            LEARN MORE
          </el-link>
        </el-row>
      </el-row>
      <el-footer class="footer">
        Powered by SRAX.
      </el-footer>
    </el-col>
    <el-col :sm="12" :class="['form-section',hasCardError ? 'flex-payment-error' : '']">
      <el-row class="panel">
        <div class="content-img">
          <img :src="getLogo" alt="">
        </div>
        <div v-if="!isSuccess">
          <div class="mt-30 mb-10">
            <el-row v-if="step < 6" class="mb-20">
              <el-steps :active="step" class="onboarding-step">
                <el-step description="Personal information"/>
                <el-step description="Create company"/>
                <el-step description="License agreement"/>
                <el-step description="Payment information"/>
                <el-step description="Review order"/>
              </el-steps>
            </el-row>
            <div class="header-contain">
              <el-row>
                <span class="title-style">
                  {{
                      step === 1 ? 'Personal information'
                    : step === 2 ? 'Create company'
                    : step === 3 ? 'License agreement'
                    : step === 4 ? 'Payment information'
                    : step === 5 ? 'Review order'
                    : 'Something went wrong'
                  }}
                </span>
              </el-row>
            </div>
            <el-row v-if="step !== 1 && step !== 4">
              <p v-if="step === 3" class="subtitle-style">
                Please read the following platform license agreement.
              </p>
              <p v-if="step === 5" class="subtitle-style">
                Please review your order before submitting your payment information.
              </p>
            </el-row>
          </div>
          <div :class="step === 3 || step === 5 || step === 6 ? 'blue-bit-25' : 'blue-bit-52'"/>
        </div>
        <div v-if="!isSuccess && !hasCardError" class="body-step">
          <el-row v-show="step === 1" :gutter="20">
            <el-form
              :model="onboardingForm"
              ref="onboardingBasicForm"
              :rules="rules"
              label-position="top"
              :disabled="isSaving"
            >
              <!-- User -->
              <el-col>
                <el-row><h4><strong>Personal information</strong></h4></el-row>
              </el-col>
              <el-col :md="12">
                <el-form-item label="First name" prop="user_first_name">
                  <el-input v-model="onboardingForm.user_first_name" />
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item label="Last name" prop="user_last_name">
                  <el-input v-model="onboardingForm.user_last_name" />
                </el-form-item>
              </el-col>

              <el-col>
                <el-form-item label="Email" prop="user_email">
                  <el-input v-model="onboardingForm.user_email" @blur="validateEmail"/>
                  <div v-if="!isEmailValid" class="el-form-item__error">
                    Email address is already in use
                  </div>
                </el-form-item>
                <el-row class="placeholder mb-10">
                  <h6>This will be used for your login.</h6>
                </el-row>
              </el-col>

              <el-col :md="12">
                <el-form-item label="Job title" prop="user_job_title">
                  <el-input v-model="onboardingForm.user_job_title" />
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item label="Phone" prop="user_phone">
                  <el-input v-model="onboardingForm.user_phone" />
                </el-form-item>
              </el-col>

              <el-col :md="12" v-if="false">
                <el-form-item label="Referrer IR Firm" prop="firm_name">
                  <el-select
                    v-model="onboardingForm.firm_name"
                    placeholder="Search"
                    class="select-to-form"
                    filterable
                    allow-create
                    :loading="isLoadingFirm"
                    @change="updateReferral"
                  >
                    <el-option
                      label="I don't have a referral"
                      value="NAA"
                    />
                    <el-option-group
                      v-for="group in firmList"
                      :key="group.label"
                      :label="group.label"
                    >
                      <el-option
                        v-for="item in group.firms"
                        :key="item.global_investor_relation_firm_id"
                        :label="item.global_investor_relation_firm_name"
                        :value="item.global_investor_relation_firm_id"
                      />
                    </el-option-group>
                  </el-select>
                </el-form-item>
              </el-col>

              <!--Referral Code-->
              <el-col :md="12">
                <el-form-item label="Referral code" prop="onboarding_referral_code">
                  <el-input v-model="onboardingForm.onboarding_referral_code" maxlength="30"/>
                </el-form-item>
              </el-col>

              <!--Account password-->

              <el-col>
                <el-row><h4><strong>Account password</strong></h4></el-row>
              </el-col>
              <el-col :md="12">
                <el-popover
                  ref="popPassword"
                  width="170"
                  placement="top"
                  trigger="hover"
                >
                  <template>
                    Password requirements:
                    <ul class="list-unstyled">
                      <li>An upper case letter</li>
                      <li>A lower case letter</li>
                      <li>A numeric character</li>
                      <li>A special character</li>
                      <li>Minimum 8 characters</li>
                    </ul>
                  </template>
                </el-popover>

                <el-form-item prop="password">
                  <template slot="label">
                    Password
                    <i
                      v-popover:popPassword
                      class="font-size-16 icon-info--circle"
                      slot="suffix"
                    />
                  </template>
                  <el-input
                    @input="calculateSecurity"
                    v-model="onboardingForm.password"
                    type="password"
                    class="input-icon"
                  >
                    <div slot="suffix">
                      <el-tooltip content="Generate" placement="top">
                        <el-button
                          icon="icon-shuffle"
                          type="text"
                          @click="generatePassword()"
                        />
                      </el-tooltip>
                    </div>
                  </el-input>
                </el-form-item>
                <p :class="`security-tag level-tag-${securityLevel}`">{{ levelTag }}</p>
                <div class="security-level">
                  <template>
                    <p
                      v-for="val in 3"
                      :key="val"
                      :class="['level', val <= securityLevel ? `fill-level-${securityLevel}` : '']"
                    />
                  </template>
                </div>
              </el-col>

              <el-col :md="12">
                <el-form-item label="Confirm password" prop="confirmPass">
                  <el-input v-model="onboardingForm.confirmPass" type="password"/>
                </el-form-item>
              </el-col>
            </el-form>

            <el-col>
              <el-row :gutter="20" class="mt-30 form-actions">
                <el-col>
                  <el-button
                    type="primary"
                    @click="validForm('onboardingBasicForm')"
                    class="continue-button"
                    size="medium"
                    native-type="submit"
                    v-track="{
                      event: 'create_continue',
                      userAttributes: [
                        {
                          isReferral: 'company_referral'
                        },
                        {
                          objectName: 'onboardingForm',
                          user_first_name: 'onboarding_user_first_name',
                          user_last_name: 'onboarding_user_last_name',
                          user_email: 'onboarding_user_email',
                          user_phone: 'onboarding_user_phone',
                          user_job_title: 'onboarding_user_job_title',
                          company_name: 'onboarding_company_name',
                          company_display_name: 'onboarding_company_display_name',
                          company_address: 'onboarding_company_address',
                          company_country_code: 'onboarding_company_country',
                          company_state: 'onboarding_company_state',
                          company_city: 'onboarding_company_city',
                          company_zip_code: 'onboarding_company_zip_code',
                          company_symbol: 'onboarding_company_stock_symbol',
                          onboarding_referral_code: 'onboarding_referral_code',
                       }
                      ]
                    }"
                  >
                    Continue
                  </el-button>
                </el-col>
                <el-col class="mt-20 color-primary">
                  Already have an account?
                  <router-link class="underline" to="/login">
                    Login
                  </router-link>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row v-show="step === 2" :gutter="20">
            <el-form
              :model="onboardingForm"
              ref="companyForm"
              :rules="rules"
              label-position="top"
              :disabled="isSaving"
            >
              <el-col :md="12">
                <el-form-item prop="company_name">
                  <template slot="label">
                    Company name
                    <el-popover
                      width="155"
                      placement="top"
                      trigger="hover"
                      content="This is the legal name of the company"
                    >
                      <i class="font-size-16 icon-info--circle" slot="reference"/>
                    </el-popover>
                  </template>
                  <el-input v-model="onboardingForm.company_name" />
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item prop="company_display_name">
                  <template slot="label">
                    Company display name
                    <el-popover
                      width="155"
                      placement="top"
                      trigger="hover"
                      content="This is the name that will be displayed in Sequire"
                    >
                      <i class="font-size-16 icon-info--circle" slot="reference"/>
                    </el-popover>
                  </template>
                  <el-input class="login-pass" v-model="onboardingForm.company_display_name">
                    <div slot="suffix">
                      <span>{{ onboardingForm.company_display_name.length}}/20</span>
                    </div>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col>
                <el-form-item label="Street address" prop="company_address">
                  <el-input v-model="onboardingForm.company_address" />
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item label="Country" prop="company_country_code">
                  <el-select
                    v-model="onboardingForm.company_country_code"
                    placeholder="Select"
                    filterable
                    @change="getStates('onboardingForm')"
                    :loading="isLoadingCountry"
                  >
                    <el-option-group>
                      <el-option
                        v-for="(itemG, idxG) in groupCountryList"
                        :key="idxG"
                        :label="itemG.country_name"
                        :value="itemG.country_code"
                      />
                    </el-option-group>
                    <el-option-group>
                      <el-option
                        v-for="(item, idx) in countryList"
                        :key="idx"
                        :label="item.country_name"
                        :value="item.country_code"
                      />
                    </el-option-group>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :md="12" v-if="isInput">
                <el-form-item label="State" prop="company_state">
                  <el-input v-model="onboardingForm.company_state" />
                </el-form-item>
              </el-col>
              <el-col :md="12" v-else>
                <el-form-item label="State" prop="company_state">
                  <el-select
                    v-model="onboardingForm.company_state"
                    placeholder="Select"
                    filterable
                    :loading="isLoadingState"
                  >
                    <el-option
                      v-for="(item, idx) in stateList"
                      :key="idx"
                      :label="item.state_name"
                      :value="item.state_code"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item label="City" prop="company_city">
                  <el-input v-model="onboardingForm.company_city" />
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item label="ZIP code" prop="company_zip_code">
                  <el-input v-model="onboardingForm.company_zip_code" />
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item label="Stock symbol" prop="company_symbol">
                  <base-select
                    v-model="onboardingForm.company_symbol"
                    remote
                    class="select-to-form"
                    :remote-method="validInput"
                    placeholder="Search symbol"
                    :loading="isLoadingSymbol"
                    filterable
                    @change="symbolSelected"
                    no-data-text="No matches were found"
                  >
                    <el-option
                      v-for="item in symbolList"
                      :key="item.symbolId"
                      :label="`${item.symbol}  -  ${item.name}`"
                      :value="item.symbol"
                      value-key="symbol"
                    >
                      <span class="pull-left">{{ item.symbol }}</span>
                      <el-tooltip :content="item.name" placement="top">
                        <span class="search-options">{{ item.name }}</span>
                      </el-tooltip>
                    </el-option>
                    <i
                      slot="prefix"
                      class="el-input__icon icon-search2"
                    />
                  </base-select>
                </el-form-item>
              </el-col>

            </el-form>

            <el-col>
              <el-row :gutter="20" class="mt-30 form-actions">
                <el-col>
                  <el-button
                    type="primary"
                    @click="validForm('companyForm')"
                    class="continue-button"
                    size="medium"
                    native-type="submit"
                    v-track="{
                      event: 'create_continue',
                      userAttributes: [
                        {
                          isReferral: 'company_referral'
                        },
                        {
                          objectName: 'onboardingForm',
                          user_first_name: 'onboarding_user_first_name',
                          user_last_name: 'onboarding_user_last_name',
                          user_email: 'onboarding_user_email',
                          user_phone: 'onboarding_user_phone',
                          user_job_title: 'onboarding_user_job_title',
                          company_name: 'onboarding_company_name',
                          company_display_name: 'onboarding_company_display_name',
                          company_address: 'onboarding_company_address',
                          company_country_code: 'onboarding_company_country',
                          company_state: 'onboarding_company_state',
                          company_city: 'onboarding_company_city',
                          company_zip_code: 'onboarding_company_zip_code',
                          company_symbol: 'onboarding_company_stock_symbol',
                          onboarding_referral_code: 'onboarding_referral_code',
                       }
                      ]
                    }"
                  >
                    Continue
                  </el-button>
                </el-col>
                <el-col class="mt-20 color-primary">
                  <el-button
                    type="text"
                    @click="updateStep('back')"
                    class="go-back"
                  >
                    Go back
                  </el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row v-show="step === 3">
            <el-col class="mb-20">
              <div id="agreementContainer" class="license-agreement" v-html="agreement" />
            </el-col>
            <el-form
              :model="onboardingForm"
              ref="onboardingAgreementForm"
              :disabled="isSaving"
            >
              <el-col>
                <el-form-item>
                  <el-checkbox
                    v-model="onboardingForm.license"
                    :disabled="!isAgreementRead"
                    class="check-license"
                  />
                  I accept all of the terms of the preceding license agreement.
                </el-form-item>
              </el-col>
            </el-form>

            <el-col>
              <el-row :gutter="20" class="mt-30 form-actions">
                <el-col>
                  <el-button
                    type="primary"
                    :disabled="!onboardingForm.license"
                    @click="updateStep('next')"
                    class="continue-button"
                    size="medium"
                    native-type="submit"
                    v-track="{ event: 'create_legal_continue' }"
                  >
                    Continue
                  </el-button>
                </el-col>
                <el-col class="mt-20 color-primary">
                  <el-button
                    type="text"
                    @click="updateStep('back')"
                    class="go-back"
                  >
                    Go back
                  </el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row v-show="step === 4" :gutter="20">
            <el-col v-if="!showPaymentErrorDetail">
              <p class="subtitle-style payment-info">
                Please enter your payment details below. You will not be charged at this time.
                This will be your default account payment method and it can be changed at any time.
              </p>
            </el-col>
            <el-col v-else class="error-message-summary">
              <el-row class="account-summary">
                <el-col class="account-info" :lg="12" :md="12">
                  <el-row><h4><strong>Account details</strong></h4></el-row>
                  <el-col :lg="12" :md="12">
                    <span>First name</span>
                    <p>{{ onboardingForm.user_first_name }}</p>
                  </el-col>
                  <el-col :lg="12" :md="12">
                    <span>Last name</span>
                    <p>{{ onboardingForm.user_last_name }}</p>
                  </el-col>
                  <el-col :lg="12" :md="12">
                    <span>Email</span>
                    <p>{{ onboardingForm.user_email }}</p>
                  </el-col>
                  <el-col :lg="12" :md="12">
                    <span>Phone</span>
                    <p>{{ onboardingForm.user_phone }}</p>
                  </el-col>
                </el-col>
                <el-col class="payment-info" :lg="12" :md="12">
                  <el-row><h4><strong>Payment method</strong></h4></el-row>
                  <el-col
                    class="warning"
                  >
                    We were unable to complete your payment with the card you entered.
                  </el-col>
                </el-col>
              </el-row>
            </el-col>
            <el-form
              :model="billingForm"
              ref="onboardingPaymentForm"
              :rules="rules"
              label-position="top"
              :disabled="isSaving"
            >
              <!-- Card details -->
              <el-col>
                <el-row><h4><strong>Card details</strong></h4></el-row>
              </el-col>
              <el-col>
                <el-form-item label="Name on card" prop="name_on_card">
                  <el-input id="name_on_card" v-model="billingForm.name_on_card" />
                </el-form-item>
              </el-col>
              <el-col class="mb-20">
                <div class="form-row mb-5">
                  <div id="card-element">
                    <!-- A Stripe Element will be inserted here. -->
                  </div>
                </div>
                <!-- Used to display form errors. -->
                <div id="card-errors" role="alert">
                  {{ tokenError }}
                </div>
              </el-col>

              <!-- Billing address -->
              <el-col class="billing-title">
                <h4><strong>Billing address</strong></h4>
                <div>
                  <el-checkbox
                    v-model="billingForm.useCompInfo"
                    @change="useCompanyInfo"
                    class="check-license"
                  />
                  Use my company address
                </div>
              </el-col>
              <el-col>
                <el-form-item label="Address line 1" prop="company_address_line_1">
                  <el-input
                    id="company_address_line_1"
                    v-model="billingForm.company_address_line_1"
                  />
                </el-form-item>
              </el-col>

              <el-col>
                <el-form-item label="Address line 2" prop="company_address_line_2">
                  <el-input
                    id="company_address_line_2"
                    v-model="billingForm.company_address_line_2"
                  />
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item label="Country" prop="company_country_code">
                  <el-select
                    v-model="billingForm.company_country_code"
                    placeholder="Select"
                    filterable
                    @change="getStates('billingForm')"
                    :loading="isLoadingCountry"
                    id="company_country_code"
                  >
                    <el-option-group>
                      <el-option
                        v-for="(itemG, idxG) in groupCountryList"
                        :key="idxG"
                        :label="itemG.country_name"
                        :value="itemG.country_code"
                      />
                    </el-option-group>
                    <el-option-group>
                      <el-option
                        v-for="(item, idx) in countryList"
                        :key="idx"
                        :label="item.country_name"
                        :value="item.country_code"
                      />
                    </el-option-group>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :md="12" v-if="isInput">
                <el-form-item label="State" prop="company_state">
                  <el-input id="company_state" v-model="billingForm.company_state" />
                </el-form-item>
              </el-col>
              <el-col :md="12" v-else>
                <el-form-item label="State" prop="company_state">
                  <el-select
                    v-model="billingForm.company_state"
                    placeholder="Select"
                    filterable
                    :loading="isLoadingState"
                  >
                    <el-option
                      v-for="(item, idx) in stateList"
                      :key="idx"
                      :label="item.state_name"
                      :value="item.state_code"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item label="City" prop="company_city">
                  <el-input id="company_city" v-model="billingForm.company_city" />
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item label="ZIP code" prop="company_zip_code">
                  <el-input id="company_zip_code" v-model="billingForm.company_zip_code" />
                </el-form-item>
              </el-col>

              <!-- Accounts payable -->
              <el-col class="billing-title">
                <h4><strong>Billing contact</strong></h4>
                <div>
                  <el-checkbox
                    v-model="billingForm.usePersonalEmail"
                    @change="usePersonalEmail"
                    class="check-license"
                  />
                  Use email from Personal information
                </div>
              </el-col>
              <el-col>
                <el-form-item label="Email" prop="payable_email">
                  <el-input v-model="billingForm.payable_email" />
                </el-form-item>
              </el-col>
            </el-form>

            <!-- Order summary -->
            <el-col>
              <el-row><h4><strong>Order summary</strong></h4></el-row>
            </el-col>
            <el-col>
              <el-table stripe :data="tableData" class="table-create-account">
                <el-table-column>
                  <template slot-scope="scope">
                    <span v-if="scope.row.strong"><strong>{{ scope.row.label }}</strong></span>
                    <span v-else>{{ scope.row.label }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="right" width="90">
                  <template slot-scope="scope">
                    <span><strong>{{ scope.row.value }}</strong></span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>

            <el-col>
              <el-row :gutter="20" class="mt-30 form-actions">
                <el-col>
                  <el-button
                    type="primary"
                    @click="validForm('onboardingPaymentForm')"
                    class="continue-button"
                    size="medium"
                    native-type="submit"
                    v-track="{ event: 'create_payment_review' }"
                  >
                    Continue
                  </el-button>
                </el-col>
                <el-col class="mt-20 color-primary">
                  <el-button
                    type="text"
                    @click="updateStep('back')"
                    class="go-back"
                  >
                    Go back
                  </el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row v-if="step === 5" :gutter="20">
            <el-form
              :model="onboardingForm"
              label-position="top"
            >
              <!-- User -->
              <el-col>
                <el-row><h4><strong>Account details</strong></h4></el-row>
              </el-col>
              <el-col :md="12">
                <el-form-item label="First name">
                  <span class="word-break">{{ onboardingForm.user_first_name }}</span>
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item label="Last name">
                  <span class="word-break">{{ onboardingForm.user_last_name }}</span>
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item label="Email">
                  <span class="word-break">{{ onboardingForm.user_email }}</span>
                </el-form-item>
              </el-col>

              <el-col :md="12">
                <el-form-item label="Phone">
                  <span class="word-break">{{ onboardingForm.user_phone }}</span>
                </el-form-item>
              </el-col>

              <!-- Payment method -->
              <el-col>
                <el-row><h4><strong>Payment method</strong></h4></el-row>
              </el-col>
              <el-col :md="12" class="payment-method mb-20">
                <div :class="['card-logo', `card-${cardInfo.brand.toLowerCase()}`]" alt="" />
                <div class="payment-details">
                  <span><strong>{{ cardInfo.brand }} </strong>{{ cardInfo.last4 }}</span>
                  <span>
                    <strong>Exp: </strong>{{ `${cardInfo.exp_month}/${cardInfo.exp_year}` }}
                  </span>
                </div>
              </el-col>

              <el-col :md="12">
                <span>{{ tokenError }}</span>
              </el-col>

              <!-- Order summary -->
              <el-col>
                <el-row><h4 class="mb-0"><strong>Order summary</strong></h4></el-row>
              </el-col>
              <el-col>
                <el-table :data="tableData" class="table-create-account">
                  <el-table-column>
                    <template slot-scope="scope">
                      <span v-if="scope.row.strong"><strong>{{ scope.row.label }}</strong></span>
                      <span v-else>{{ scope.row.label }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="right" width="90">
                    <template slot-scope="scope">
                      <span><strong>{{ scope.row.value }}</strong></span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-form>

            <el-col>
              <el-row :gutter="20" class="mt-30 form-actions">
                <el-col>
                  <el-button
                    type="primary"
                    @click="postForms"
                    class="continue-button"
                    size="medium"
                    :disabled="isSaving"
                    :loading="isSaving"
                    v-track="{ event: 'create_order' }"
                  >
                    Place my order
                  </el-button>
                </el-col>
                <el-col class="mt-20 color-primary">
                  <el-button
                    type="text"
                    @click="updateStep('back')"
                    class="go-back"
                    :disabled="isSaving"
                  >
                    Go back
                  </el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div v-if="isSuccess" class="body-step">
          <div class="account-ready-contain">
            <el-row>
              <img
                srcset="~assets/img/onboarding/account-ready-1x.png 200w,
                 ~assets/img/onboarding/account-ready-2x.png 400w,
                  ~assets/img/onboarding/account-ready-3x.png 600w"
                alt=""
                class="account-ready-img"
              >
            </el-row>
            <el-row class="mt-30">
              <span class="title-style">Your account is ready!</span>
              <p class="subtitle-style">Login and start enjoying the features of Sequire.</p>
            </el-row>
            <el-row class="mt-30">
              <el-button
                type="primary"
                @click="goToLogin"
                class="continue-button"
                size="medium"
              >
                Go to login
              </el-button>
            </el-row>
          </div>
        </div>
        <div v-if="hasCardError">
          <el-row class="mt-30">
            <p>
              There was a problem with your payment method. Please verify your payment details
              or try using a different payment method.
            </p>
          </el-row>
          <el-row class="mt-30">
            <el-button
              type="primary"
              @click="tryAgain"
              class="continue-button"
              size="medium"
            >
              Try with a different card
            </el-button>
          </el-row>
        </div>
      </el-row>
      <el-footer v-if="hasCardError" class="any-question">
        <span><strong>Having trouble?</strong></span>
        <span>Contact us at
          <a href="mailto:support@mysequire.com">support@mysequire.com</a>
          for further help.</span>
      </el-footer>
    </el-col>
    <el-col class="info-section is-mobile">
      <el-row class="panel onboarding-info">
        <h1>The Future of <br>Stock Surveillance</h1>
        <el-row class="onboarding-description">
          Sequire unlocks stock buyers’ behaviors and trends for issuers of
          publicly traded companies.
        </el-row>
        <el-row>
          <el-link
            href="https://mysequire.com/"
            target="_blank"
            :underline="false"
            v-track="{ event: 'login_learn' }"
          >
            LEARN MORE
          </el-link>
        </el-row>
      </el-row>
      <el-footer class="footer">
        Powered by SRAX.
      </el-footer>
    </el-col>
    <base-pixel pixelType="google" v-if="isSuccess" target="AW-673514969/KQi7CM-Qz7oBENmLlMEC" />
    <base-pixel pixelType="google" target="AW-673514969/G_DmCKOyz7oBENmLlMEC" />
    <base-pixel pixelType="facebook" />
    <base-pixel pixelType="twitter" />
    <base-pixel pixelType="linkedIn" />
    <base-pixel pixelType="appnexus" v-if="isValidInformation" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { generate } from 'generate-password';
import Vue from 'vue';
import BaseSelect from '@/components/Select';
import BasePixel from '@/components/BasePixel';
import { debounce } from '@/util';
import { objectUnique } from '@/util/helper';
import { getBrand } from '@/whitelabel.config';
import { HTTP } from '@/store/service';

window.onload = (() => {
  document.getElementById('name_on_card').value = '';
  document.getElementById('company_address_line_1').value = '';
  document.getElementById('company_address_line_2').value = '';
  document.getElementById('company_country_code').value = '';
  document.getElementById('company_state').value = '';
  document.getElementById('company_city').value = '';
  document.getElementById('company_zip_code').value = '';
});

export default {
  name: 'onboarding',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '' && this.rules.password[0].required) callback(new Error('Please enter the password'));
      else {
        if (this.onboardingForm.confirmPass !== '') this.$refs.onboardingBasicForm.validateField('confirmPass');
        callback();
      }
    };
    const confirmPass = (rule, value, callback) => {
      if (value === '' && this.rules.confirmPass[0].required) callback(new Error('Please enter the password again'));
      else if (value !== this.onboardingForm.password) callback(new Error('Password doesn\'t match!'));
      else callback();
    };

    return {
      tableData: [{
        label: 'Monthly subscription charge',
        value: '$1,000',
      }, {
        label: 'Sales tax',
        value: '$0.00',
      }, {
        label: 'TOTAL',
        value: '$1,000',
        strong: true,
      }],
      brand: getBrand(),
      isSaving: false,
      isLoadingSymbol: false,
      isLoadingCheckEmail: false,
      isLoadingLicense: false,
      isLoadingFirm: false,
      isLoadingState: false,
      isLoadingCountry: false,
      isEmailValid: true,
      isSuccess: false,
      isReferral: false,
      isParentMatch: false,
      isValidInformation: false,
      hasCardError: false,
      showPaymentErrorDetail: false,
      isInput: true,
      isAgreementRead: false,
      symbolList: [],
      groupCountryList: [],
      countryList: [],
      stateList: [],
      firmList: [],
      firmMatch: [],
      securityLevel: 0,
      step: 1,
      step3Init: false,
      show3dAuthModal: false,
      parentCompanyId: '',
      redirectUrl: '',
      onboarding_company_id: '',
      onboarding_user_id: '',
      agreement: '',
      agreementFileID: '',
      levelTag: '',
      postCompanySuccess: false,
      postUserSuccess: false,
      postPaymentSuccess: false,
      paymentSecret: '',
      creditCardFilled: false,
      onboardingForm: {
        user_first_name: '',
        user_last_name: '',
        user_email: '',
        user_phone: '',
        user_job_title: '',
        company_name: '',
        company_display_name: '',
        company_symbol: '',
        company_address: '',
        company_city: '',
        company_zip_code: '',
        company_state: '',
        company_country_code: '',
        firm_name: 'NAA',
        password: '',
        license: false,
        confirmPass: '',
        onboarding_referral_code: '',
      },
      billingForm: {
        name_on_card: '',
        company_address_line_1: '',
        company_address_line_2: '',
        company_city: '',
        company_zip_code: '',
        company_state: '',
        company_country_code: '',
        useCompInfo: false,
        usePersonalEmail: false,
        payable_email: '',
      },
      stripe: '',
      elements: '',
      card: '',
      stripeInfo: {},
      exchangeShortNameList: [
        'CV EM',
        'Greys',
        'OTCQB',
        'OTCPK',
        'OTCQK',
      ],
      cardInfo: {
        brand: 'unknown',
        last4: '',
        exp_month: '',
        exp_year: '',
      },
      tokenError: '',
      rules: {
        user_first_name: [
          {
            required: true,
            message: 'Please enter first name',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 100,
            message: 'Length should be min 2 to 100 characters',
            trigger: 'blur',
          },
          {
            pattern: '^[A-Za-z\\s]+$',
            message: 'The field accepts only letters and spaces',
            trigger: 'blur',
          },
        ],
        user_last_name: [
          {
            required: true,
            message: 'Please enter last name',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 100,
            message: 'Length should be min 2 to 100 characters',
            trigger: 'blur',
          },
          {
            pattern: '^[A-Za-z\\s]+$',
            message: 'The field accepts only letters and spaces',
            trigger: 'blur',
          },
        ],
        user_email: [
          {
            required: true,
            message: 'Please enter email',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: 'Please enter correct email',
            trigger: 'blur',
          },
        ],
        user_phone: [
          {
            pattern: '^\\+?[0-9]{0,3} ?(\\(?[0-9]{3}\\)?([\\s|-])?[0-9]{3}([\\s|-])?[0-9]{4})$',
            message: 'Invalid phone number',
            trigger: 'blur',
          },
        ],
        company_name: [
          {
            required: true,
            message: 'Please enter company name',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 100,
            message: 'Length should be min 3 to 100 characters',
            trigger: 'blur',
          },
        ],
        firm_name: [
          {
            required: false,
            message: 'Referrer IR firm required',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 50,
            message: 'Length should be min 3 to 50 characters',
            trigger: 'change',
          },
        ],
        company_display_name: [
          {
            required: true,
            message: 'Please enter company display name',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 20,
            message: 'Length should be min 3 to 20 characters',
            trigger: 'blur',
          },
        ],
        user_job_title: [
          {
            required: true,
            message: 'Please enter job title',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 100,
            message: 'Length should be min 3 to 100 characters',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur',
          },
          {
            min: 8,
            message: 'Length should be min 8 characters',
            trigger: 'blur',
          },
          {
            pattern: '^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()\\-_~=+\\[\\]{};:.?,\\\\])^[A-Za-z\\d!@#$%^&*()\\-_~=+\\[\\]{};:.?,\\\\\\\\]{8,30}$',
            message: 'Password format error',
            trigger: 'blur',
          },
        ],
        confirmPass: [
          {
            required: true,
            validator: confirmPass,
            trigger: 'blur',
          },
        ],
        company_address: [
          {
            required: true,
            message: 'Please enter street address',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 100,
            message: 'Length should be min 3 to 100 characters',
            trigger: 'blur',
          },
        ],
        company_address_line_1: [
          {
            required: true,
            message: 'Please enter address line 1',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 100,
            message: 'Length should be min 3 to 100 characters',
            trigger: 'blur',
          },
        ],
        company_address_line_2: [
          {
            required: false,
            message: 'Please enter address line 2',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 100,
            message: 'Length should be min 3 to 100 characters',
            trigger: 'blur',
          },
        ],
        company_city: [
          {
            required: true,
            message: 'Please enter a city',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 100,
            message: 'Length should be min 2 to 100 characters',
            trigger: 'blur',
          },
        ],
        company_state: [
          {
            required: true,
            message: 'Please enter a state',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 100,
            message: 'Length should be min 2 to 100 characters',
            trigger: 'blur',
          },
        ],
        company_zip_code: [
          {
            required: true,
            message: 'Please enter a ZIP code',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 20,
            message: 'Length should be min 3 to 20 characters',
            trigger: 'blur',
          },
        ],
        company_country_code: [
          {
            required: true,
            message: 'Please select a country',
            trigger: 'blur',
          },
        ],
        name_on_card: [
          {
            required: true,
            message: 'Please enter a name',
            trigger: 'blur',
          },
        ],
        payable_email: [
          {
            required: true,
            message: 'Please enter billing contact email',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: 'Please enter correct email address',
            trigger: 'blur',
          },
        ],
        company_symbol: [
          {
            required: true,
            message: 'Please select a symbol',
            trigger: 'change',
          },
        ],
        onboarding_referral_code: [
          {
            pattern: '^[a-zA-Z0-9_]{1,30}$',
            message: 'The field only accepts alphanumeric',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  components: {
    BaseSelect,
    BasePixel,
  },
  computed: {
    ...mapState({
      isDark: (state) => state.layout.isDark,
    }),
    getLogo() {
      if (this.isDark && Object.prototype.hasOwnProperty.call(this.brand.logoList, 'loginDark')) return this.brand.logoList.loginDark;
      return this.brand.logoList.login;
    },
  },
  methods: {
    symbolSelected() {
      this.tableData[0].value = '$1,000';
      this.tableData[2].value = '$1,000';
      /* const aux = this.symbolList.filter((e) => e.symbol === symbol);
      if (this.exchangeShortNameList.includes(aux[0].exchangeShortName)) {
        this.tableData[0].value = '$1,500';
        this.tableData[2].value = '$1,500';
      } else {
        this.tableData[0].value = '$3,000';
        this.tableData[2].value = '$3,000';
      } */
    },
    updateReferral(val) {
      const regex = RegExp('^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$');
      this.isReferral = regex.test(val);
    },
    tryAgain() {
      this.hasCardError = false;
      this.showPaymentErrorDetail = true;
      this.updateStep('', 4);
    },
    goToLogin() {
      this.$router.push('/login');
    },
    async postForms() {
      try {
        this.isSaving = true;
        if (!this.postCompanySuccess) await this.postCompany();
        if (!this.postUserSuccess) await this.postUser();
        if (!this.postPaymentSuccess) await this.postPayment();

        if (
          this.postUserSuccess === true
          && this.postCompanySuccess === true
          && this.postPaymentSuccess === true
        ) {
          this.updateStep('', 6);
          // open the success view
          this.isSuccess = true;
          this.isSaving = false;
        } else {
          this.updateStep('', 5);
          // open the success view
          this.isSuccess = false;
          this.isSaving = false;
        }
      } catch (e) {
        Vue.config.errorHandler(e);
        this.isSaving = false;
        throw e;
      }
    },
    async postUser() {
      try {
        const method = 'post';
        const url = `onboarding/users?onboarding_company_id=${this.onboarding_company_id}`;
        const data = {
          onboarding_user: {
            onboarding_user_first_name: this.onboardingForm.user_first_name,
            onboarding_user_last_name: this.onboardingForm.user_last_name,
            onboarding_user_password: this.onboardingForm.password,
            onboarding_user_phone_number: this.onboardingForm.user_phone,
            onboarding_user_email: this.onboardingForm.user_email,
            onboarding_user_job_title: this.onboardingForm.user_job_title,
          },
        };
        if (data.onboarding_user.onboarding_user_phone_number === '') delete data.onboarding_user.onboarding_user_phone_number;
        const res = await HTTP({ method, url, data });
        this.onboarding_user_id = res.data.data.onboarding_user_id;
        this.postUserSuccess = true;
      } catch (e) {
        this.postUserSuccess = false;
        Vue.config.errorHandler(e);
        throw e;
      }
    },
    async postCompany() {
      try {
        const method = 'post';
        const url = 'onboarding/companies';
        const data = {
          onboarding_company: {
            onboarding_company_name: this.onboardingForm.company_display_name,
            onboarding_company_full_name: this.onboardingForm.company_name,
            onboarding_company_address: this.onboardingForm.company_address,
            onboarding_company_country_code: this.onboardingForm.company_country_code,
            onboarding_company_city: this.onboardingForm.company_city,
            onboarding_company_state: this.onboardingForm.company_state,
            onboarding_company_zip_code: this.onboardingForm.company_zip_code,
            onboarding_company_symbol: this.onboardingForm.company_symbol,
            onboarding_company_ir_firm: { no_referral: true },
            onboarding_payable_email: this.billingForm.payable_email,
            onboarding_system_file_id: this.agreementFileID,
            onboarding_referral_code: this.onboardingForm.onboarding_referral_code,
          },
        };
        if (data.onboarding_company.onboarding_referral_code === '') delete data.onboarding_company.onboarding_referral_code;
        if (data.onboarding_company.onboarding_company_symbol === '') delete data.onboarding_company.onboarding_company_symbol;
        // removed code to enabled referrar ir firm field
        /* if (this.isParentMatch) {
          data.onboarding_company.onboarding_company_ir_firm
            .onboarding_company_ir_firm_id = this.firmMatch[0].global_investor_relation_firm_id;
        } else {
          const regex =
           RegExp('^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$');
          if (this.onboardingForm.firm_name === 'NAA') data.onboarding_company
          .onboarding_company_ir_firm.no_referral = true;
          else if (regex.test(this.onboardingForm.firm_name)) {
            data.onboarding_company.onboarding_company_ir_firm
              .onboarding_company_ir_firm_id = this.onboardingForm.firm_name;
          } else {
            data.onboarding_company.onboarding_company_ir_firm
              .onboarding_company_ir_firm_name = this.onboardingForm.firm_name;
          }
        } */

        const res = await HTTP({ method, url, data });
        this.onboarding_company_id = res.data.data.onboarding_company_id;
        this.postCompanySuccess = true;
      } catch (e) {
        this.postCompanySuccess = false;
        Vue.config.errorHandler(e);
        throw e;
      }
    },
    async postPayment() {
      try {
        const method = 'post';
        const url = `onboarding/payment?onboarding_company_id=${this.onboarding_company_id}&onboarding_user_id=${this.onboarding_user_id}`;
        const data = {
          payment_method: {
            method: 'card',
            card_token: this.stripeInfo.token.id,
          },
        };
        const res = await HTTP({ method, url, data });
        if (res.status === 202) { // 202
          this.paymentSecret = res.data.data.client_secret;
          this.redirectUrl = res.data.data.next_action.url;
          this.show3dAuthModal = true;
          this.postPaymentSuccess = false;
          this.updateStep('', 5);
        } else if (res.status === 422) { // 422
          this.hasCardError = true;
          this.showPaymentErrorDetail = true;
          this.postPaymentSuccess = false;
          this.updateStep('', 4);
        } else { // 200
          this.postPaymentSuccess = true;
        }
      } catch (e) {
        this.hasCardError = true;
        this.showPaymentErrorDetail = true;
        this.postPaymentSuccess = false;
        this.updateStep('', 6);
        Vue.config.errorHandler(e);
        throw e;
      }
    },
    async getStates(form) {
      try {
        this.isLoadingState = true;
        this.isInput = !(this[form].company_country_code === 'CA' || this[form].company_country_code === 'US');
        this.stateList = [];
        this[form].company_state = '';

        if (!this.isInput) {
          const method = 'get';
          const url = 'onboarding/states';
          const params = {
            country_code: this[form].company_country_code,
            limit: 500,
            sort: 'state_name',
          };
          const res = await HTTP({ method, url, params });
          if (res.status === 200) this.stateList = res.data.data;
          this.isLoadingState = false;
        }
      } catch (e) {
        Vue.config.errorHandler(e);
        this.isLoadingState = false;
        throw e;
      }
    },
    async getCountries() {
      try {
        this.isLoadingCountry = true;
        const method = 'get';
        const url = 'onboarding/countries';
        const params = {
          sort: 'country_name',
          limit: 500,
        };
        const res = await HTTP({ method, url, params });
        if (res.status === 200) {
          res.data.data.map((currentValue) => {
            if (currentValue.country_code === 'US') {
              this.groupCountryList.push(currentValue);
              return null;
            }
            this.countryList.push(currentValue);
            return currentValue;
          });
        }
        this.isLoadingCountry = false;
      } catch (e) {
        Vue.config.errorHandler(e);
        this.isLoadingCountry = false;
        throw e;
      }
    },
    validForm(formName) {
      this.executeTrim();
      this.$nextTick(() => {
        this.$refs[formName].validate(async (valid) => {
          const displayError = document.getElementById('card-errors');
          if (!valid) {
            if (this.step === 1) this.validateEmail();
            if (this.step === 4 && !this.creditCardFilled) displayError.textContent = 'Please enter a valid credit card information';
            return;
          }
          if (this.step === 1) this.validateEmail({}, true);
          else if (this.step === 4) {
            if (!this.creditCardFilled) {
              displayError.textContent = 'Please enter a valid credit card information';
              return;
            }
            displayError.textContent = '';
            await this.createStripeToken();
            if (!this.hasCardError) this.updateStep('next');
          } else this.updateStep('next');
        });
      });
    },
    async validateEmail(el, isSubmit = false) {
      try {
        this.isEmailValid = true;
        if (!this.isValidEmail(this.onboardingForm.user_email) || this.isLoadingCheckEmail) return;
        this.isLoadingCheckEmail = true;
        const method = 'get';
        const url = 'onboarding/users/checkEmail';
        const params = {
          user_email: this.onboardingForm.user_email,
        };
        const res = await HTTP({ method, url, params });
        this.isEmailValid = res.status === 200 && res.data.data.is_available;
        if (isSubmit && this.isEmailValid) {
          this.updateStep('next');
          this.isValidInformation = true;
        }
        this.isLoadingCheckEmail = false;
      } catch (e) {
        this.isLoadingCheckEmail = false;
        throw e;
      }
    },
    isValidEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    executeTrim() {
      this.onboardingForm.user_first_name = this.onboardingForm.user_first_name.trim();
      this.onboardingForm.user_last_name = this.onboardingForm.user_last_name.trim();
      this.onboardingForm.user_email = this.onboardingForm.user_email.trim();
      this.onboardingForm.user_phone = this.onboardingForm.user_phone.trim();
      this.onboardingForm.user_job_title = this.onboardingForm.user_job_title.trim();
      this.onboardingForm.company_name = this.onboardingForm.company_name.trim();
      this.onboardingForm.company_display_name = this.onboardingForm.company_display_name.trim();
      this.onboardingForm.company_address = this.onboardingForm.company_address.trim();
      this.onboardingForm.company_city = this.onboardingForm.company_city.trim();
      this.onboardingForm.company_zip_code = this.onboardingForm.company_zip_code.trim();
      this.onboardingForm.company_state = this.onboardingForm.company_state.trim();
      this.onboardingForm.firm_name = this.onboardingForm.firm_name.trim();

      this.billingForm.payable_email = this.billingForm.payable_email.trim();
      this.billingForm.name_on_card = this.billingForm.name_on_card.trim();
      this.billingForm.company_address_line_1 = this.billingForm.company_address_line_1.trim();
      this.billingForm.company_address_line_2 = this.billingForm.company_address_line_2.trim();
      this.billingForm.company_city = this.billingForm.company_city.trim();
      this.billingForm.company_zip_code = this.billingForm.company_zip_code.trim();
      this.billingForm.company_state = this.billingForm.company_state.trim();
    },
    calculateSecurity(pass) {
      this.$refs.onboardingBasicForm.validateField('password', (valid) => {
        /*
          lower   [0]
          upper   [1]
          numeric [2]
          special [3]
        */
        const characters = Array(4).fill(0);
        this.levelTag = '';
        this.securityLevel = 0;
        if (!valid) {
          pass.split('').forEach((el) => {
            if (/[a-z]/.test(el)) characters[0] += 1;
            if (/[A-Z]/.test(el)) characters[1] += 1;
            if (/\d/.test(el)) characters[2] += 1;
            const patt = new RegExp('^(?=.*[!@#$%^&*()\\-_~=+\\[\\]{};:.?,\\\\])');
            if (patt.test(el)) characters[3] += 1;
          });
          switch (characters.filter((e) => e > 1).length) {
            case 3:
            case 4:
              this.securityLevel = 2;
              this.levelTag = 'Medium';
              break;
            case 5:
              this.securityLevel = 3;
              this.levelTag = 'Strong';
              break;
            default:
              this.securityLevel = 1;
              this.levelTag = 'Weak';
          }
        }
      });
    },
    validInput(symbol) {
      debounce(async () => {
        if (symbol.trim().length >= 1) {
          this.getSymbol(symbol.trim());
        }
      }, 800)();
    },
    async getSymbol(symbol) {
      try {
        this.isLoadingSymbol = true;
        this.symbolList = [];
        const method = 'get';
        const url = 'onboarding/marketData/smartLookUp';
        const params = {
          symbol,
        };
        const res = await HTTP({ method, url, params });
        if (res.status === 200) this.symbolList = objectUnique(res.data.data, 'symbolId');
        this.isLoadingSymbol = false;
      } catch (error) {
        Vue.config.errorHandler(error);
        this.isLoadingSymbol = false;
        throw error;
      }
    },
    async getLicense() {
      try {
        this.isLoadingLicense = true;
        const method = 'get';
        const url = 'onboarding/agreement';
        const res = await HTTP({ method, url });
        if (res.status === 200) {
          let file = res.data.data.file_content;
          file = file.split('body>', 2)[1];
          file = file.substring(0, file.length - 2);
          file += '<div id="agreementEnd" />';
          this.agreement = file;
          this.agreementFileID = res.data.data.system_file_id;
        }
        this.isLoadingLicense = false;
      } catch (error) {
        Vue.config.errorHandler(error);
        this.isLoadingLicense = false;
        throw error;
      }
    },
    async updateStep(action, step = null) {
      if (step) this.step = step;
      else if (action === 'next') {
        this.step += 1;
        this.isInput = true;
      } else this.step -= 1;

      if (this.step === 3) {
        debounce(() => {
          this.createListener();
        }, 250)();
      }

      if (this.step === 4) {
        this.creditCardFilled = false;
        // get color text value
        const style = getComputedStyle(document.body);
        const colorText = style.getPropertyValue('--color-text');
        await this.hasScript();
        await this.loadScript();
        this.stripe = window.Stripe(process.env.STRIPE.KEY);
        this.elements = this.stripe.elements();
        this.card = this.elements.create('card', {
          hidePostalCode: true,
          style: {
            base: {
              color: colorText,
            },
          },
        });
        if (!this.step3Init) {
          this.step3Init = true;
          this.clearBillingForm();
        }
        setTimeout(() => {
          this.card.mount('#card-element');
          this.createListeners();
        }, 300);
      }
    },
    generatePassword() {
      const passLength = Math.floor(Math.random() * ((16 - 8) + 1)) + 8;
      const password = generate({
        length: passLength,
        numbers: true,
        symbols: true,
        uppercase: true,
        strict: true,
      });
      const regex = RegExp(this.rules.password[2].pattern);
      if (regex.test(password)) {
        this.onboardingForm.password = password;
        this.onboardingForm.confirmPass = password;
        this.calculateSecurity(this.onboardingForm.password);
      } else this.generatePassword();
    },
    async validateParentCompany() {
      try {
        const origin = window.location.origin;
        const method = 'get';
        const url = 'onboarding/parentCompanySettings';
        const params = {
          platform_url: origin,
        };
        const res = await HTTP({ method, url, params });
        this.parentCompanyId = (res.data.data[0] && res.data.data[0].parent_company_id) || '';
      } catch (e) {
        this.isSaving = false;
        throw e;
      }
    },
    async getFirms() {
      try {
        this.isLoadingFirm = true;
        this.firmList = [];
        const method = 'get';
        const url = 'onboarding/globalInvestorRelationFirms';
        const params = {
          sort: 'global_investor_relation_firm_name',
          only_whitelabel: true,
          limit: 200,
        };
        const res = await HTTP({ method, url, params });
        if (res.status === 200) {
          const firms = {
            label: 'IR Firms',
            firms: res.data.data,
          };
          this.firmList.push(firms);
          this.firmMatch = this.firmList[0].firms
            .filter((el) => el.whitelabel_company_id === this.parentCompanyId);
          this.isParentMatch = this.firmMatch.length > 0;
          this.isReferral = this.firmMatch.length > 0;
        }
        this.isLoadingFirm = false;
      } catch (error) {
        Vue.config.errorHandler(error);
        this.isLoadingFirm = false;
        throw error;
      }
    },
    async useCompanyInfo() {
      if (this.billingForm.useCompInfo) {
        this.billingForm.company_address_line_1 = this.onboardingForm.company_address;
        this.billingForm.company_address_line_2 = '';
        this.billingForm.company_city = this.onboardingForm.company_city;
        this.billingForm.company_zip_code = this.onboardingForm.company_zip_code;
        this.billingForm.company_state = this.onboardingForm.company_state;
        this.billingForm.company_country_code = this.onboardingForm.company_country_code;

        await this.getStates('billingForm');
        this.billingForm.company_state = this.onboardingForm.company_state;
      }
    },
    usePersonalEmail() {
      if (this.billingForm.usePersonalEmail) {
        this.billingForm.payable_email = this.onboardingForm.user_email;
        this.$refs.onboardingPaymentForm.validateField('payable_email');
      }
    },
    createListener() {
      document.getElementsByClassName('license-agreement')[0].addEventListener('scroll', this.scrollPosition);
    },
    scrollPosition() {
      const agrEndPosition = (document.getElementById('agreementContainer').offsetHeight
        + document.getElementsByClassName('license-agreement')[0].scrollTop);
      if (agrEndPosition >= document.getElementById('agreementEnd').offsetTop) this.isAgreementRead = true;
    },
    async loadScript() {
      return new Promise((resolve, reject) => {
        const head = document.head || document.getElementsByTagName('head')[0];
        const script = document.createElement('script');
        script.async = true;
        script.src = process.env.STRIPE.JS;
        script.charset = 'utf-8';

        head.appendChild(script);

        script.onload = resolve;
        script.onerror = reject;
      });
    },
    hasScript() {
      const elemiframe = document.querySelectorAll('iframe');
      if (elemiframe.length > 0) {
        for (let i = 0; i < elemiframe.length; i += 1) {
          const iframe = elemiframe[i];
          if (iframe.getAttribute('src') && iframe.getAttribute('src').includes('js.stripe.com')) {
            iframe.parentNode.removeChild(iframe);
          }
        }
      }
      const elemscript = document.querySelectorAll('script');
      if (elemscript.length > 0) {
        for (let i = 0; i < elemscript.length; i += 1) {
          const script = elemscript[i];
          if (script.getAttribute('src') && script.getAttribute('src').includes('js.stripe.com')) {
            script.parentNode.removeChild(script);
          }
        }
      }
    },
    createListeners() {
      // changes on card input
      this.card.addEventListener('change', ((event) => {
        this.creditCardFilled = event.complete;
        const displayError = document.getElementById('card-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
          this.creditCardFilled = false;
        } else {
          displayError.textContent = '';
        }
      }));
    },
    async createStripeToken() {
      await this.stripe.createToken(this.card, {
        name: this.billingForm.name_on_card,
        address_line1: this.billingForm.company_address_line_1,
        address_line2: this.billingForm.company_address_line_2,
        address_city: this.billingForm.company_city,
        address_state: this.billingForm.company_state,
        address_zip: this.billingForm.company_zip_code,
        address_country: this.billingForm.company_country_code,
      }).then((result) => {
        if (result.error) {
          // Inform the user if there was an error.
          this.tokenError = result.error.message;
          this.hasCardError = true;
        } else {
          // Send the token to your server.
          this.stripeInfo = result;
          this.cardInfo.brand = result.token.card.brand;
          this.cardInfo.last4 = result.token.card.last4;
          this.cardInfo.exp_year = `${result.token.card.exp_year}`.substr(2, 2);
          this.cardInfo.exp_month = result.token.card.exp_month < 10
            ? `0${result.token.card.exp_month}`
            : result.token.card.exp_month;
          this.tokenError = '';
          this.hasCardError = false;
        }
      });
    },
    clearOnboardingForm() {
      // MS Edge
      this.onboardingForm = {
        user_first_name: '',
        user_last_name: '',
        user_email: '',
        user_phone: '',
        user_job_title: '',
        company_name: '',
        company_display_name: '',
        company_symbol: '',
        company_address: '',
        company_city: '',
        company_zip_code: '',
        company_state: '',
        company_country_code: '',
        firm_name: 'NAA',
        password: '',
        license: false,
        confirmPass: '',
      };
    },
    clearBillingForm() {
      // MS Edge
      this.billingForm = {
        name_on_card: '',
        company_address_line_1: '',
        company_address_line_2: '',
        company_city: '',
        company_zip_code: '',
        company_state: '',
        company_country_code: '',
        useCompInfo: false,
        usePersonalEmail: false,
        payable_email: '',
      };
    },
    listener3D(e) {
      if (e.data.event === 'payment-transaction-success') {
        if (window.location.pathname !== '/signup') return;
        if (this.stripe && this.paymentSecret) {
          this.stripe.retrieveSetupIntent(this.paymentSecret)
            .then((result) => {
              if (result.error) {
                // setupIntent client secret was invalid
                this.hasCardError = true;
                this.showPaymentErrorDetail = true;
                this.postPaymentSuccess = false;
                this.updateStep('', 4);
              } else {
                this.hasCardError = false;
                this.showPaymentErrorDetail = false;
                if (result.setupIntent.status === 'succeeded') {
                  // Show your customer that the payment has succeeded
                  this.postForms();
                  this.postPaymentSuccess = true;
                } else {
                  // Authentication failed, prompt the customer to enter another payment method
                  this.hasCardError = true;
                  this.showPaymentErrorDetail = true;
                  this.postPaymentSuccess = false;
                  this.updateStep('', 6);
                }
              }
            });
        }
        this.show3dAuthModal = false;
      }
    },
  },
  created() {
    const self = this;
    window.addEventListener('message', self.listener3D);
  },
  beforeMount() {
    const html = document.getElementById('html-base');

    if (this.$store.state.layout.isDark) html.classList.add('dark');
    else html.classList.remove('dark');
  },
  async mounted() {
    this.clearOnboardingForm();
    await this.validateParentCompany();
    // this.getFirms();
    this.getLicense();
    this.getCountries();
  },
  beforeDestroy() {
    window.removeEventListener('message', this.listener3D);
  },
};
</script>

<style lang="scss">
@import "~@/styles/variables.scss";

.onboarding-step {
  .el-step__description {
    margin-top: 5px;
  }
  .el-step__description.is-finish {
    color: $--color-primary!important;
  }
}
</style>
<style scoped lang="scss">
  @import "~@/styles/variables.scss";

  .any-question {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    margin-left: 60px;
    margin-bottom: 20px;
  }

  .flex-payment-error {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .account-ready-contain {
    margin-top: 60px;
  }

  .account-ready-img {
    width: 326px;
    max-height: 100%;
    object-fit: cover;
  }

  .mb-0 {
    margin-bottom: 0;
  }

  .check-license {
    margin-right: 10px;
  }

  .form-actions {
    text-align: center;

    .underline {
      text-decoration: underline;
    }

    .go-back {
      font-size: 16px;
      text-decoration: underline;
    }
  }

  .placeholder {
    color: $--color-text-variant;

    h6 {
      margin-top: 0;
    }
  }

  .color-primary {
    color: $--color-primary;
  }

  .continue-button, .el-select, .select-to-form {
    width: 100%;
  }

  .search-options {
    float: right;
    color: #8492a6;
    font-size: 13px;
    width: 120px;
    text-overflow: ellipsis;
    white-space:nowrap;
    overflow:hidden;
  }

  .security-level {
    display: flex;
    justify-content: space-between;
    width: 70%;

    .level {
      width: 32%;
      height: 5px;
      background-color: $--color-disabled;
    }
  }

  .security-tag {
    font-size: 10px;
  }

  .level-tag-1 {
    color: $--color-security-weak!important;
  }

  .level-tag-2 {
    color: $--color-security-medium!important;
  }

  .level-tag-3 {
    color: $--color-security-strong!important;
  }

  .fill-level-1 {
    background-color: $--color-security-weak!important;
  }
  .fill-level-2 {
    background-color: $--color-security-medium!important;
  }
  .fill-level-3 {
    background-color: $--color-security-strong!important;
  }

  .create-body {
    height: 100%;
    min-height: 890px;
    background: #12151d;
  }

  // new structure
  .is-mobile {
    display: none!important;
  }

  .info-section {
    background-image: url('~assets/img/onboarding/bg-1x.png');
    background-image:
      -webkit-image-set(
        url('~assets/img/onboarding/bg-1x.png') 1x,
        url('~assets/img/onboarding/bg-2x.png') 2x,
        url('~assets/img/onboarding/bg-3x.png') 3x,
      );
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    .panel {
      margin: 165px 65px 0;
      color: $--color-primary-variant!important;

      h1 {
        font-size: 32px;
        font-weight: 700;
        line-height: 39px;
      }
      div {
        font-size: 16px;
        line-height: 19px;
        margin-top: 20px;
        margin-bottom: 20px;
      }
      a {
        color: $--color-primary;
        font-size: 16px;
        font-weight: bold;
        line-height: 19px;
        text-decoration: underline;
      }
    }

    .footer {
      color: $--color-white;
      margin-left: 45px;
      font-weight: bold;
    }
  }

  .form-section {
    border-radius: 12px 0 0 12px;
    background: $--color-surface;
    overflow: auto;
    height: 100%;

    ::v-deeplabel {
      color:$--color-text-variant;
      &:before{
        color:$--color-text-variant!important;
      }
    }

    .panel {
      margin: 70px 80px;

      .header-contain {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: $--color-primary;
      }

      .subtitle-style {
        color: $--color-text;
        font-size: 16px;
        margin-top: 15px;
      }

      .payment-info {
        margin-top: 0;
        margin-bottom: 27px;
      }

      .body-step {
        margin-top: 27px;
      }

      .content-img {
        height: 45px;
        img {
          height: 100%;
        }
      }

      .title-style {
        color: $--color-primary;
        font-size: 32px;
        font-weight: bold;
        line-height: 43px;
      }

      .blue-bit-25 {
        width: 25px;
        height: 5px;
        background: $--color-primary;
      }

      .blue-bit-52 {
        width: 52px;
        height: 5px;
        background: $--color-primary;
      }
    }
  }

  .learn-more-link ::v-deep .el-link--inner {
    color: $--color-primary;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: 1065px) {
    .form-section {
      .panel {
        margin: 70px 40px;

        .header-contain {
          display: block;
        }
      }

      .any-question {
        margin-left: 20px;
      }
    }

    .info-section {
      .panel {
        margin: 165px 40px;
      }
    }
  }

  @media (max-width: 767px) {
    .form-section {
      overflow: auto;
      height: auto;
      border-radius: 0;
    }

    .account-ready-contain {
      text-align: center;
    }

    .account-ready-img {
      width: 241px;
    }

    .is-mobile {
      height: auto;
      display: block!important;
      text-align: center;

      .panel {
        margin: 0;
        h1 {
          font-size: 24px;
          margin-top: 40px;
        }
      }

      .footer {
        margin-left: 0;
        margin-bottom: 20px;
      }
    }

    .is-desktop {
      display: none!important;
    }
  }

  .license-agreement {
    height: 400px;
    border-radius: 4px;
    border: 1px solid $--color-line;
    overflow: auto;
    padding: 20px;
  }

  .StripeElement {
    box-sizing: border-box;
    height: 40px;
    padding: 10px 12px;
    border: 1px solid $--color-text-variant;
    border-radius: 6px;
    box-shadow: none;
    background-color: $--color-surface;
    -webkit-transition: none;
    transition: none;
  }

  .StripeElement--focus {
    box-shadow: none;
  }

  .StripeElement--invalid {
    border-color: $--color-danger;
  }

  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }

  #card-errors {
    color: $--color-danger;
    font-size: 11px;
  }

  .payment-method {
    display: flex;
    align-items: center;

    .card-logo {
      height: 30px;
      width: 50px;
    }

    .payment-details {
      margin-left: 10px;
      display: flex;
      flex-direction: column;
    }
  }

  @media (min-width: 500px) {
    .billing-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .is-desktop {
    .onboarding-info {
      h1 {
        font-weight: bold!important;
        line-height: 39px!important;
        color: $--color-white;
      }

      .onboarding-description {
        line-height: 19px!important;
        max-width: 70%;
        color: $--color-white;
      }

      .mb-25 {
        margin-bottom: 25px!important;
      }
      .mt-30 {
        margin-top: 30px!important;
      }
    }
  }

  .is-mobile {
    .onboarding-info {
      h1 {
        font-weight: normal!important;
        font-size: 24px!important;
        line-height: 29px!important;
      }

      .onboarding-description {
        max-width: 50%;
        text-align: center;
        display: inline-block;
      }
    }
  }

  .error-message-summary {
    &.el-col {
      padding: 0!important;
      margin-left: -10px;
      margin-right: -10px;
    }
    .account-summary {
      border-radius: 1px;
      background-color: #f8f9fd;
      padding: 15px 20px;
      h4 {
        margin-bottom: 20px;
      }
    }
    .warning {
      color: #FA4646;
    }
    span {
      color: #A4A4A4;
    }
    p {
      padding-top: 10px;
      padding-bottom: 15px;
      overflow-x: hidden;
      text-overflow: ellipsis
    }
  }

  .modalIframe {
    border-width: 0px;
    width: 100%;
    height: 500px;
  }
</style>
